import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { ChannelService, ChannelEvent } from 'src/app/services/channel.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-guest-payment-modal',
  templateUrl: './guest-payment-modal.component.html',
  styleUrls: ['./guest-payment-modal.component.less']
})
export class GuestPaymentModalComponent implements OnInit, OnDestroy {

  @Input() aptexxGuestPaymentLink: string;
  @Output() processed$: Subject<boolean> = new Subject<boolean>();
  $gstPmt : Subscription;
  constructor(public sanitizer: DomSanitizer, public modalService: NgbModal, public channels : ChannelService, public auth : AuthService) { }
  ngOnDestroy(): void {
    try {
      this.$gstPmt.unsubscribe();
      
    } catch (error) {
      
    }
    
  }

  ngOnInit() {
    this.$gstPmt = this.channels.sub("GuestPayment").subscribe((ev : ChannelEvent)=>{
      console.warn('GUEST PAYMENT PROCESSED',ev);
      this.modalService.dismissAll();
      this.processed$.next(true);
    })
    // this.paymentProcessedSub$ = this.processed$.subscribe((res: boolean) => { 
    //   //if the payment successfully processed, we need to close the dialog
    //   if(res === true) {
    //     this.modalService.dismissAll();
    //   }
    // })
  }
}
